import React, { useState } from "react";
import { BAD_BG, BAD_INK, INK_2, INK_3 } from "../bureauTokens";

// Reprend .mp-alert de mon-poste.css tel quel : chaque ligne a TOUJOURS un
// fond teinté "alerte" (ce sont des dossiers en cours, donc à surveiller),
// le client en haut à gauche (gras, bad-ink), l'étape en dessous (ink-2),
// et le statut à droite (bad-ink si en retard, ink-3 si "ok").
function RecapItemRow({ client, sub, right, tone = "ok", onClick }) {
  const [hover, setHover] = useState(false);
  const late = tone !== "ok";

  return (
    <button
      onClick={onClick}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      className="w-full grid items-center text-left transition-[filter]"
      style={{
        gridTemplateColumns: "1fr auto",
        gap: "1px 8px",
        background: BAD_BG,
        borderRadius: 9,
        padding: "7px 9px",
        filter: hover ? "brightness(.97)" : "none",
      }}
    >
      <span className="text-[10px] font-semibold truncate" style={{ color: BAD_INK }}>
        {client}
      </span>
      <span
        className="text-[9px] font-bold whitespace-nowrap row-span-2 self-center justify-self-end"
        style={{ color: late ? BAD_INK : INK_3 }}
      >
        {right}
      </span>
      <span className="text-[9px] truncate" style={{ color: INK_2, gridColumn: 1 }}>
        {sub}
      </span>
    </button>
  );
}

export default RecapItemRow;
